import { cmsModule } from '@utils';

export default [...cmsModule('heading'), cmsModule('intro'), cmsModule('jobs')];
